import Ratings from './Ratings'

export { Ratings as default }
export type { RatingsProps } from './Ratings.types'
